import { render, staticRenderFns } from "./DeleteEmployeeDialog.vue?vue&type=template&id=19324e1c"
import script from "./DeleteEmployeeDialog.vue?vue&type=script&lang=js"
export * from "./DeleteEmployeeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports